import { ApiRequestEnum } from 'src/app/core/enums/api-request.enum';
import { ApiService } from 'src/app/core/services/api.service';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	constructor(
		private apiService: ApiService,
	) {
	}

	login(params) {
		return this.apiService.post(ApiRequestEnum.AUTH_LOGIN, params);
	}

	doRegister(params) {
		return this.apiService.post(ApiRequestEnum.AUTH_REGISTER, params);
	}

	forgotPassword(params) {
		return this.apiService.post(ApiRequestEnum.AUTH_FORGOT_PWD, params);
	}

	resetPassword(params) {
		return this.apiService.post(ApiRequestEnum.AUTH_RESET_PWD, params);
	}

	UpdateProfile(params: Object) {
		return this.apiService.put(ApiRequestEnum.PROFILE_UPDATE, params);
	}

	DeleteAcount(params: string) {
		return this.apiService.delete(ApiRequestEnum.DELETE_ACCOUNT);
	}

	WishlistItems(params: Object) {
		return this.apiService.post(ApiRequestEnum.WishlistItems, params);
	}

	AddItemToWishlist(params: any) {
		return this.apiService.put(ApiRequestEnum.AddItemToWishlist.replace('{{itemId}}', params))
	}

	DeleteItemToWishlist(params: any) {
		return this.apiService.delete(ApiRequestEnum.DeleteItemToWishlist.replace('{{itemId}}', params))
	}

	GetShippingAddress() {
		return this.apiService.get(ApiRequestEnum.GetShippingAddress);
	}

	AddShippingAddress(params) {
		return this.apiService.post(ApiRequestEnum.ADDSHIPPINGADDRESS, params)
	}

	CreateVisitor(params: any) {
		return this.apiService.post(ApiRequestEnum.Visior, params)
	}

	CUSTOMER_DO_LOGOUT() {
		return this.apiService.get(ApiRequestEnum.LogOut)
	}

	ResendOtp(params: any) {
		return this.apiService.post(ApiRequestEnum.ResendOtp, params)
	}

	GetCityAndStateFromZipcode(params: any) {
		return this.apiService.post(ApiRequestEnum.GetCityAndStateFromZipcode, params)
	}
}
